import { CardContent, Grid2 as Grid, Typography, Card } from "@mui/material"
import React from "react"
import { api } from "../../../../../../../../../../interfaces/interfaces"
import { RightioWBSAPIModelsAccountCodes, RightioWBSAPIModelsSPSpBookingGetLastJobResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from "@utils/apis/wbs/endpoints"

const name = "AccountCard"

type AccountCardProps = {
    parent: string
    job?: RightioWBSAPIModelsSPSpBookingGetLastJobResult
    jobDetails: RightioWBSAPIModelsSPSpJobsGetJobDetailsResult | undefined
}

const getAccountInfo = async (accountCode: number) => {
    const accountInfo = await api.fetchAccountCodeNoOverride({ accountCode })
    return accountInfo
}

const AccountCard: React.FC<AccountCardProps> = ({ parent, job, jobDetails }) => {
    const [accountInfo, setAccountInfo] = React.useState<RightioWBSAPIModelsAccountCodes>()

    React.useEffect(() => {
        if (job?.accountCode) {
            getAccountInfo(job?.accountCode).then(setAccountInfo)
        }
    }, [job?.accountCode])

    return (
        (< Card sx={{ mb: 1 }}>
            <CardContent>
                {jobDetails?.jobId &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Booking Id:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.jobId}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.accountCode &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Account Code:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: jobDetails?.accountCode === 33500 ? "red" : "blue" }}>{jobDetails?.accountCode}</span></Typography>
                        </Grid>
                    </Grid>}
                {accountInfo?.accountType &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Account Type:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: jobDetails?.accountType === "CARECLUB" ? "red" : "blue" }}>{accountInfo?.accountType}</span></Typography>
                        </Grid>
                    </Grid>}
                {accountInfo?.localNumber &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Local Number:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{accountInfo?.localNumber}</span></Typography>
                        </Grid>
                    </Grid>}
                {accountInfo?.introduction &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Name:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{accountInfo?.introduction}</span></Typography>
                        </Grid>
                    </Grid>}
                {accountInfo?.tradeCode &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >TradeCode:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{accountInfo?.tradeCode}</span></Typography>
                        </Grid>
                    </Grid>}
                {accountInfo?.postcodeArea &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Postcode Area:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{accountInfo?.postcodeArea}</span></Typography>
                        </Grid>
                    </Grid>}
            </CardContent>
        </Card >)
    );
}

AccountCard.displayName = name

export default React.memo(AccountCard)

